import React from 'react';
import FormROValue from '../../../library/form/components/FormROValue1';
import SarasIconImage from '../../../library/decor/avatar/SarasIconImage';
import DocRowContainer from '../../cmn/DocRowContainer';
import FormAttachment from '../../../library/form/components/FormAttachment';
import FormWrapper from '../../../library/form/components/FormWrapper';
// import SarasDnDCard from '../../../library/hooks/bdnd/SarasDnDCard';
import SarasDnDCard from '../../../library/hooks/dndkit/SarasDnDCard';

const DocImageRow = (props) => {
    const { formObject, index, rowKey, isSortMode } = props;
    return (
        <SarasDnDCard rowKey={rowKey} index={index} isSortMode={isSortMode}>
            <div>
                <DocRowContainer formObject={formObject} rowKey={rowKey} actionClass="uiActionBlock uiColumnCenter"
                    containerClass="uiBoxImage uiContentCenter uiBorderRoundAll uiBoxSection150"
                >
                    <div className="uiAccessory">
                        <FormWrapper customWrapper="span" wrapperClass="" formObject={formObject} 
                            rowKey={rowKey} action={{ paramName: "isDefaultIndicator" }} >
                            <SarasIconImage className="uiSarasIcon" icon="defaultTick"></SarasIconImage>
                        </FormWrapper>
                        <FormWrapper customWrapper="span" wrapperClass="" formObject={formObject} 
                            rowKey={rowKey} action={{ paramName: "showOnAppIndicator" }} >
                            <SarasIconImage className="uiSarasIcon" icon="appTick"></SarasIconImage>
                        </FormWrapper>
                        <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "docType" }} />
                        <FormROValue formObject={formObject} className="uiSpacerH5 uiBlue" rowKey={rowKey} action={{ paramName: "sortNoIndicator" }} />
                    </div>
                    <div className="uiFileBlock uiColumnCenter">
                        <FormAttachment formObject={formObject} rowKey={rowKey} action={{ InputType: "i", paramName: "imageLink" }} />
                    </div>
                    <div style={{fontSize:'11px',height:'15px',overflow:'hidden'}} >
                        <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "desc" }} />
                    </div>
                </DocRowContainer>
                </div>
        </SarasDnDCard>
    )
}

export default DocImageRow
